import { STORE_HOST } from './index';
import { getJSON } from './ultile';
import { times } from '../../utiles/officialStore';
import { storeBirthCoupons, getBirthCoupons } from './storager';
import {
  JPSTORE_PAY_COUPON_LIST,
  JPSTORE_COUPON_LIST,
  JPSTORE_SHORT_HOST,
  JPSTORE_SEND_VIP_COUPON
} from './jp';
import { popupType, showPopup } from '../../plugins/biPoint/_configWebstoreV1';
export const SET_GAME_COUPON_ENTRY_SHOW_STATUS =
  'set_game_coupon_entry_show_status';
export const SET_GAME_COUPON_POPUP_SHOW_STATUS =
  'set_game_coupon_popup_show_status';
export const SET_VIP_COUPON_SHOW_STATUS = 'set_vip_coupon_show_status';
export const SET_BIRTH_COUPON_SHOW_STATUS = 'set_birth_coupon_show_status';
export const SET_ACTIVITY_COUPON_SHOW_STATUS = 'set_activity_coupon_show_status';
export const SET_GAME_COUPON_ITEM_USE_BTN = 'set_game_coupon_item_use_btn';
export const UPDATE_GAME_ENABLE_COUPON_LIST = 'update_game_enable_coupon_list';
export const UPDATE_GAME_DISABLE_COUPON_LIST =
  'update_game_disable_coupon_list';
export const UPDATE_GAME_EXPIRE_COUPON_LIST = 'update_game_expire_coupon_list';
export const UPDATE_VIP_COUPON_LIST = 'update_vip_coupon_list';
export const UPDATE_BIRTH_COUPON_LIST = 'update_birth_coupon_list';
export const UPDATE_VIP_LEVEL = 'update_vip_level';
export const UPDATE_VIP_NEXT_LEVEL_POINT = 'update_vip_next_level_point';
export const UPDATE_VIP_SUM_POINT = 'update_vup_sum_point';
export const UPDATE_GAME_ACTIVE_COUPON_ID = 'update_game_active_coupon_id';
export const LOAD_GAME_COUPON_LIST = 'load_game_coupon_list';
export const LOAD_VIP_COUPON_INFO = 'load_vip_coupon_info';
export const SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS =
  'set_paytype_coupon_popup_show_status';
export const UPDATE_PAYTYPE_ENABLE_COUPON_LIST =
  'update_paytype_enable_coupon_list';
export const UPDATE_PAYTYPE_DISABLE_COUPON_LIST =
  'update_paytype_disable_coupon_list';
export const UPDATE_PAYTYPE_EXPIRE_COUPON_LIST =
  'update_paytype_expire_coupon_list';
export const UPDATE_PAYTYPE_ACTIVE_COUPON_ID =
  'update_paytype_active_coupon_id';
export const LOAD_PAYTYPE_COUPON_LIST = 'load_paytype_coupon_list';

const PAYTYPE_COUPON_LIST_ACTION = 'coupon/get_pay_coupon_list';
const GAME_COUPON_LIST_ACTION = 'coupon/get_coupon_list';
const VIP_COUPON_INFO_ACTION = 'coupon/send_coupons';

export default {
  state: {
    isShowGameItemUseBtn: false, // 是否显示优惠券的立即使用按钮
    isShowGameCouponEntry: false, // 是否显示游戏优惠券入口
    isShowGameCouponPopup: false, //是否显示游戏优惠券列表
    isShowVipCouponPopup: false, //是否展示VIP积分优惠券弹窗
    isShowBirthCouponPopup: false, //是否展示生日优惠券弹窗
    isShowActivityCouponPopup: false, //是否展示活动优惠券弹窗
    gameCouponEnableList: [], // 游戏优惠券列表 - 可用
    gameCouponDisableList: [], // 游戏优惠券列表 - 不可用：无效
    gameCouponExpireList: [], // 游戏优惠券列表 - 不可用：过期
    gameActiveCouponId: '', // 游戏选中的优惠券Id
    isShowPaytypePopupCoupon: false, //是否显示渠道优惠券弹窗
    paytypeEnableCouponList: [], //渠道优惠券列表 - 可用
    paytypeDisableCouponList: [], //渠道优惠券列表 - 不可用：无效
    paytypeExpireCouponList: [], //渠道优惠券列表 - 不可用：过期
    paytypeActiveCouponId: '', //渠道选中的优惠券Id
    vipSumPoint: 0, // 用户积分
    vipLevel: 0, // 用户VIP等级
    vipNextLevelPoint: 0, //VIP满足下一等级的积分
    vipCouponList: [], // VIP发放的优惠券列表
    birthCouponList: [], // 生日发放的优惠券列表
  },
  getters: {
    activeGameCouponProductList: state => {
      let res = [];
      let activeCoupon = state.gameCouponEnableList.filter(item => {
        return item.COUPON_ID == state.gameActiveCouponId;
      });
      activeCoupon &&
        activeCoupon.length &&
        activeCoupon[0].PRODUCT_LIST &&
        activeCoupon[0].PRODUCT_LIST.forEach(productItem => {
          res.push(productItem);
        });
      return res;
    },
    activePaytypeCouponInfo(state) {
      let index = -1;
      for (let i = 0; i < state.paytypeEnableCouponList.length; i++) {
        if (
          state.paytypeEnableCouponList[i].COUPON_ID ==
          state.paytypeActiveCouponId
        ) {
          index = i;
          break;
        }
      }
      return index !== -1 ? state.paytypeEnableCouponList[index] : [];
    },
    activePaytypeCouponFullReductType(_state, getters) {
      return +getters.activePaytypeCouponInfo.TYPE === 0;
    },
    activePaytypeCouponDiscountType(_state, getters) {
      return +getters.activePaytypeCouponInfo.TYPE === 1;
    },
    activePaytypeCouponReductPrice(_state, getters) {
      return +getters.activePaytypeCouponInfo.REDUCTION_MONEY || 0;
    },
    activePaytypeCouponReductionName(_state, getters) {
      return (
        '- ' +
        getters.activePaytypeCouponInfo.REDUCTION_MONEY +
        ' ' +
        getters.activePaytypeCouponInfo.CURRENCY
      );
    },
    activePaytypeCouponDiscountName(_state, getters) {
      return times(getters.activePaytypeCouponInfo.DISCOUNT, 100) + '%OFF';
    }
  },
  mutations: {
    [SET_GAME_COUPON_ITEM_USE_BTN](state, status) {
      state.isShowGameItemUseBtn = status;
    },
    [SET_GAME_COUPON_ENTRY_SHOW_STATUS](state, status) {
      state.isShowGameCouponEntry = status;
    },
    [SET_GAME_COUPON_POPUP_SHOW_STATUS](state, status) {
      state.isShowGameCouponPopup = status;
    },
    [SET_VIP_COUPON_SHOW_STATUS](state, status) {
      state.isShowVipCouponPopup = status;
    },
    [SET_BIRTH_COUPON_SHOW_STATUS](state, status) {
      state.isShowBirthCouponPopup = status;
      if (status) {
        showPopup(popupType.birthCouponPopup);
      }
    },
    [SET_ACTIVITY_COUPON_SHOW_STATUS](state, status) {
      state.isShowActivityCouponPopup = status;
    },
    [UPDATE_VIP_SUM_POINT](state, status) {
      state.vipSumPoint = status;
    },
    [UPDATE_VIP_LEVEL](state, status) {
      state.vipLevel = status;
    },
    [UPDATE_VIP_NEXT_LEVEL_POINT](state, status) {
      state.vipNextLevelPoint = status;
    },
    [UPDATE_VIP_COUPON_LIST](state, status) {
      state.vipCouponList = status;
    },
    [UPDATE_BIRTH_COUPON_LIST](state, list) {
      if (list && list?.length > 0) {
        state.birthCouponList =
          list?.filter(item => item?.SOURCE_ID === 'birthday') || [];
        // TODO:测试使用优惠券
        // state.birthCouponList = [
        //   {
        //     DISCOUNT: 0.1,
        //     PRODUCT_LIST: [],
        //     LOGIN_ACCOUNT: 'globaltest3',
        //     USED_ORDER_ID: '',
        //     GAME_ID: 213,
        //     TYPE: 1,
        //     STATE: 0,
        //     REDUCTION_LEVEL: '',
        //     LIMIT_TOP_LEVEL: '',
        //     USE_TIME: 0,
        //     PRODUCT_TYPE: '',
        //     START_TIME: 1704254761,
        //     EXPIRY_TIME: 1704513960,
        //     COUPON_ID: 'VIP213L1213USD20240103120600105958',
        //     USER_ID: '1000000015',
        //     LIMIT_BOTTOM_LEVEL: '',
        //     REDUCTION_MONEY: '0.00',
        //     LIMIT_BOTTOM_MONEY: '0',
        //     PAY_TYPE_LIST: [],
        //     GET_TIME: 1704254761,
        //     DESCRIPTION: 'VIP213L1\u5916',
        //     SOURCE_ID: 'vip_week',
        //     COUPON_TYPE: 'VIP213L1',
        //     CURRENCY: 'USD',
        //     LIMIT_TOP_MONEY: '0'
        //   }
        // ];
        const isShowedBirthCoupons = getBirthCoupons();
        const newBirthCoupons = state.birthCouponList.filter(
          item => !isShowedBirthCoupons.includes(item?.COUPON_ID)
        );
        if (newBirthCoupons.length > 0) {
          state.isShowBirthCouponPopup = true;
          storeBirthCoupons(state.birthCouponList.map(item => item?.COUPON_ID));
          showPopup(popupType.birthCouponPopup);
        }
      } else {
        state.birthCouponList = [];
      }
    },
    [UPDATE_GAME_ENABLE_COUPON_LIST](state, list) {
      state.gameCouponEnableList = list;
    },
    [UPDATE_GAME_DISABLE_COUPON_LIST](state, list) {
      state.gameCouponDisableList = list;
    },
    [UPDATE_GAME_EXPIRE_COUPON_LIST](state, list) {
      state.gameCouponExpireList = list;
    },
    [UPDATE_GAME_ACTIVE_COUPON_ID](state, id) {
      state.gameActiveCouponId = id;
    },
    [SET_PAYTYPE_COUPON_POPUP_SHOW_STATUS](state, status) {
      state.isShowPaytypePopupCoupon = status;
    },
    [UPDATE_PAYTYPE_ENABLE_COUPON_LIST](state, list) {
      state.paytypeEnableCouponList = list;
    },
    [UPDATE_PAYTYPE_DISABLE_COUPON_LIST](state, list) {
      state.paytypeDisableCouponList = list;
    },
    [UPDATE_PAYTYPE_EXPIRE_COUPON_LIST](state, list) {
      state.paytypeExpireCouponList = list;
    },
    [UPDATE_PAYTYPE_ACTIVE_COUPON_ID](state, id) {
      state.paytypeActiveCouponId = id;
    },
  },
  actions: {
    [LOAD_GAME_COUPON_LIST]({ commit, rootState, rootGetters }) {
      return new Promise((resolve, reject) => {
        let host = '';
        let path = '';
        if (rootGetters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_COUPON_LIST;
        } else {
          host = STORE_HOST;
          path = GAME_COUPON_LIST_ACTION;
        }
        getJSON(host + path, {
          game_id: rootState.gameId
        }).then(({ errmsg, data }) => {
          if (!errmsg) {
            if (data.enable && data.enable.length) {
              commit(UPDATE_GAME_ENABLE_COUPON_LIST, data.enable);
              commit(UPDATE_BIRTH_COUPON_LIST, data.enable);
            }
            data.disable &&
              data.disable.length &&
              commit(UPDATE_GAME_DISABLE_COUPON_LIST, data.disable);
            data.expire &&
              data.expire.length &&
              commit(UPDATE_GAME_EXPIRE_COUPON_LIST, data.expire);
            commit(SET_GAME_COUPON_ENTRY_SHOW_STATUS, true);
            resolve(true);
          } else {
            reject(errmsg);
          }
        });
      });
    },
    [LOAD_VIP_COUPON_INFO]({ commit, rootState, rootGetters }) {
      return new Promise((_resolve, reject) => {
        let host = '';
        let path = '';
        if (rootGetters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_SEND_VIP_COUPON;
        } else {
          host = STORE_HOST;
          path = VIP_COUPON_INFO_ACTION;
        }
        getJSON(host + path, {
          game_id: rootState.gameId
        }).then(({ errmsg, data }) => {
          if (!errmsg) {
            commit(UPDATE_VIP_LEVEL, data.vip_lv);
            commit(UPDATE_VIP_SUM_POINT, data.sum_points);
            commit(UPDATE_VIP_NEXT_LEVEL_POINT, data.next_lv_points);
            // TOTO：测试使用优惠券
            // data.send_coupons = [
            //   {
            //     DISCOUNT: 0.1,
            //     PRODUCT_LIST: [],
            //     LOGIN_ACCOUNT: 'globaltest3',
            //     USED_ORDER_ID: '',
            //     GAME_ID: 213,
            //     TYPE: 1,
            //     STATE: 0,
            //     REDUCTION_LEVEL: '',
            //     LIMIT_TOP_LEVEL: '',
            //     USE_TIME: 0,
            //     PRODUCT_TYPE: '',
            //     START_TIME: 1704254761,
            //     EXPIRY_TIME: 1704513960,
            //     COUPON_ID: 'VIP213L1213USD20240103120600105958',
            //     USER_ID: '1000000015',
            //     LIMIT_BOTTOM_LEVEL: '',
            //     REDUCTION_MONEY: '0.00',
            //     LIMIT_BOTTOM_MONEY: '0',
            //     PAY_TYPE_LIST: [],
            //     GET_TIME: 1704254761,
            //     DESCRIPTION: 'VIP213L1\u5916',
            //     SOURCE_ID: 'vip_week',
            //     COUPON_TYPE: 'VIP213L1',
            //     CURRENCY: 'USD',
            //     LIMIT_TOP_MONEY: '0'
            //   }
            // ];
            if (data.send_coupons && data.send_coupons.length) {
              commit(UPDATE_VIP_COUPON_LIST, data.send_coupons);
              commit(SET_VIP_COUPON_SHOW_STATUS, true);
            }
          } else {
            reject(errmsg);
          }
        });
      });
    },
    [LOAD_PAYTYPE_COUPON_LIST]({ commit, rootGetters }, param) {
      return new Promise((resolve, reject) => {
        let host = '';
        let path = '';
        if (rootGetters.isJpPlatform) {
          host = JPSTORE_SHORT_HOST;
          path = JPSTORE_PAY_COUPON_LIST;
        } else {
          host = STORE_HOST;
          path = PAYTYPE_COUPON_LIST_ACTION;
        }
        getJSON(host + path, param).then(({ errmsg, data }) => {
          if (!errmsg) {
            data.enable &&
              commit(UPDATE_PAYTYPE_ENABLE_COUPON_LIST, data.enable);
            data.disable &&
              commit(UPDATE_PAYTYPE_DISABLE_COUPON_LIST, data.disable);
            data.expire &&
              commit(UPDATE_PAYTYPE_EXPIRE_COUPON_LIST, data.expire);
            resolve(true);
          } else {
            reject(errmsg);
          }
        });
      });
    }
  }
};
